import {Card} from 'react-bootstrap'
import styled from 'styled-components'

const CardBodyContentContainer = styled(Card.Body)<{ height: number, backgroundColorType: 'card' | 'card-card' }>`
    gap: 20px;
    padding: 20px;
    border-radius: 16px;
    overflow: hidden;
    background-color: ${props => props.backgroundColorType == 'card' ? 'var(--card-bg-color)' : 'var(--card-card-bg-color)'};
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
    min-height: ${props => props.height}px;

    color: var(--text-color);
`

CardBodyContentContainer.defaultProps = {
    height: 0,
    backgroundColorType: 'card'
}

export default CardBodyContentContainer
